import React from 'react'
import { TEXT_KEY } from '@mc/feature-variables'
import { UrgencyCopy, UrgencyCopyProps } from './UrgencyCopy'

export const UrgencyText = (props: Omit<UrgencyCopyProps, 'textKey'>) => (
  <UrgencyCopy {...props} textKey={TEXT_KEY} />
)
